function split(path) {
  return {
    beginningPath: path.slice(0, path.length - 1) || [],
    endValue: path.slice(path.length - 1, path.length)[0],
  };
}

function getOrCreatePath(obj, path) {
  let ref = obj;
  path.forEach((part) => (ref = ref[part] || (ref[part] = {})));
  return ref;
}

function getOrCreateState(obj, statePath, defaultVal = false) {
  const path = split(statePath);
  const ref = getOrCreatePath(obj, path.beginningPath);
  return path.endValue ? ref[path.endValue] || (ref[path.endValue] = defaultVal) : ref;
}

function setOrCreateState(obj, statePath, value) {
  const path = split(statePath);
  const ref = getOrCreatePath(obj, path.beginningPath);
  return path.endValue ? (ref[path.endValue] = value) : Object.assign(ref, value);
}

export const LoadStateMixin = (superclass) =>
  class extends superclass {
    async attemptAsyncWithLoadUpdate(fn, stateNameOrPath) {
      const topLevelState = !Array.isArray(stateNameOrPath);
      const statePath = topLevelState ? [stateNameOrPath] : stateNameOrPath;
      const path = split(statePath);
      const currentValue = getOrCreateState(this.state, path.beginningPath);
      if (!currentValue[path.endValue]) {
        const newState = {};
        const newValue = topLevelState ? {} : {...currentValue};
        newValue[path.endValue] = true;
        setOrCreateState(newState, path.beginningPath, newValue);
        this.update(newState);
        const returnVal = await fn();
        setOrCreateState(newState, statePath, false);
        this.update(newState);
        return returnVal;
      }
    }
  };
